import { Component, contentChildren, effect, ChangeDetectionStrategy } from '@angular/core'
import { TimelineStepComponent } from './timeline-step/timeline-step.component'

@Component({
  selector: 'lib-timeline',
  imports: [],
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './timeline.component.scss',
})
export class TimelineComponent {
  readonly steps = contentChildren(TimelineStepComponent)

  private _ = effect(() => {
    const steps = this.steps()
    for (let i = 0; i < steps.length; i++) {
      steps[i].showProgress.set(i < steps.length - 1)
    }
  })
}
